<template>
  <span class="dropdown-header">Accueil</span>
  <small class="bi-three-dots nav-subtitle-replacer"></small>
  <div class="nav-item">
    <router-link
      :to="{ name: 'Dashboard' }"
      class="nav-link"
      active-class="active"
      data-placement="left"
    >
      <i class="bi-house-door nav-icon"></i>
      <span class="nav-link-title">Tableau de bord</span>
    </router-link>
  </div>
</template>
